import { selectEnv } from 'common-nextjs';

export const homepagePageViewId = selectEnv(48, 9);
export const microBannerPageViewId = selectEnv(155767, 109073);
export const navigationPageViewId = selectEnv(156170, 109097);

export const sellerTricksPageViewId = selectEnv(14, 7);
